import { render } from "./AdCreativeBox.vue?vue&type=template&id=70fe18a6&scoped=true"
import script from "./AdCreativeBox.vue?vue&type=script&lang=js"
export * from "./AdCreativeBox.vue?vue&type=script&lang=js"

import "./AdCreativeBox.vue?vue&type=style&index=0&id=70fe18a6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70fe18a6"]])

export default __exports__